import React from 'react';
import { MainMonthBlockForm } from '../../../../components/MainInMonth/MainMonthBlockForm';

export default function Form({ type }: { type: 'new' | 'edit' }) {
  return (
    <MainMonthBlockForm
      type={type}
      stepBack={3}
      name={`${type === 'new' ? 'Створити' : 'Редагувати'} блок шаблону Текстове поле`}
      fields={{
        title: { require: false },
        description: { require: true },
      }}
    />
  );
}
